module.exports = __webpack_public_path__ + "img/stanbic_ibtc_bank.f8b099f1.svg";